export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8267.801ee4d1.jpg";